import AddIcon from "@mui/icons-material/Add";
import { Box, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import GlobalButton from "../../../components/button";
import DynamicTable from "../../../components/dynamicTable";
import AppHeader from "../../../components/header";
import AppLoader from "../../../components/loader";
import { getAllProducts, updateProduct } from "../../../services/ProductApi";
import { handleApiCall, handleOpenSnackBar } from "../../../utils/helper";
import AddEditProductDialog from "./AddEditProductDialog";

const tableHeader = ["Created At", "Name", "Status", "Actions"];

const displayRows = ["lead_created_date", "name", "custom_status", "actions"];

const ProductPage = () => {
  const openAddEditDialog = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]);

  useEffect(() => {
    fetchAllProducts();
  }, []);

  const fetchAllProducts = async () => {
    try {
      setIsLoading(true);
      const response = await getAllProducts();
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setAllProducts(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpateProductStatus = async (row, e) => {
    handleApiCall(
      row._id,
      updateProduct,
      { status: e },
      setIsLoading,
      () => {},
      fetchAllProducts
    );
  };

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />
      <Box>
        <Stack
          direction={"row"}
          alignItems={"flex-end"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
          gap={2}
          mb={2}
        >
          <Typography
            variant="primaryText"
            component={"h1"}
            fontSize={{ xs: "1.5rem", md: "1.75rem" }}
          >
            List Of Products
          </Typography>
          <GlobalButton
            variant="custom_gradient"
            title="Add Product"
            startIcon={<AddIcon />}
            style={{
              width: { xs: "100%", sm: "auto" },
              borderRadius: "100px",
            }}
            handleClickBtn={() =>
              openAddEditDialog.current.openDialog({
                type: "add",
                data: null,
                getData: fetchAllProducts,
              })
            }
          />
        </Stack>

        <DynamicTable
          tableData={allProducts || []}
          displayRows={displayRows}
          tableHeader={tableHeader}
          showEdit={true}
          handleChangeCustomStatus={handleUpateProductStatus}
          handleEdit={(row) => {
            openAddEditDialog.current.openDialog({
              type: "edit",
              data: row,
              getData: fetchAllProducts,
            });
          }}
        />
        {allProducts?.length === 0 && isLoading === false && (
          <Typography variant="h5" fontWeight={600} textAlign={"center"}>
            No Data Found !
          </Typography>
        )}

        <AddEditProductDialog ref={openAddEditDialog} />
      </Box>
    </AppHeader>
  );
};

export default ProductPage;
